import { useState } from "react";
import GenerateProposalModal from "./GenerateProposalModal";
import OffersModal from "./OffersModal";
import ListDocumentsModal from "./ListDocumentsModal";
import PersonalInfo from "./PersonalInfo";

interface CrefazModalProps {
  onBack: () => void;
  onClose?: () => void;
}

export default function CrefazModal({ onBack, onClose }: CrefazModalProps) {
  const [step, setStep] = useState<
    | "generate"
    | "offers"
    | "listDocuments"
    | "PersonalInfo"
  >("generate");

  if (step === "generate") {
    return (
      <GenerateProposalModal
        onBack={onBack}
        onContinue={() => setStep("offers")}
      />
    );
  }

  if (step === "offers") {
    return (
      <OffersModal
        onBack={() => setStep("generate")}
        onContinue={() => setStep("listDocuments")}
      />
    );
  }

  if (step === "listDocuments") {
    return (
      <ListDocumentsModal
        onBack={() => setStep("offers")}
        onContinue={() => setStep("PersonalInfo")}
      />
    );
  }

  if (step === "PersonalInfo") {
    return (
      <PersonalInfo
        onBack={() => setStep("listDocuments")}
        onFinish={onClose || onBack}
      />
    );
  }

  return null;
}
